/* istanbul ignore file */
import React from 'react';
import { FieldProps, LinkField, useFieldHelper } from 'framework/ui/field';
import { useEntityUrl } from 'framework/routing';

const VACANCY_GROUP_PATH = '/vacancy-group';

const VacancyGroupLinkField = ({ source, nameSource, value, nameValue, getLinkText, ...props }: FieldProps) => {
  const { getValue: getId } = useFieldHelper({ source, value });
  const { getValue: getName } = useFieldHelper({ source: nameSource, value: nameValue });
  const { getSingleEntityUrl } = useEntityUrl({
    baseLink: VACANCY_GROUP_PATH,
  });

  const id = getId();
  const name = getName();
  const linkUrl = id && getSingleEntityUrl(id);
  const linkText = nameSource || nameValue ? name : id;

  return (
    <LinkField {...props} linkText={getLinkText ? getLinkText({ id, name }) : linkText} value={linkUrl as string} />
  );
};

export default VacancyGroupLinkField;
